export default "__VITE_ASSET__BxF5Cg7d__"